// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: '히트포 온라인 얼티밋',
  freeTimesLimitTitle: '무료 평가판은 오늘 소진되었습니다.',
  fileSizeLimitTitle: '무료 버전에서는 파일 크기가 20MB를 초과할 수 없습니다.',
  freeImgCutoutTimesLimitTitle:
    '오늘의 백그라운드 제거 무료기회는 모두 종료되었습니다. 모든 프리미엄 기능에 액세스하려면 Pro로 업그레이드하십시오.',
  total: '총가격',
  enterCode: '코드 입력',
  signUpToPurchaseBtn: '등록하고 구입하기',
  goPurchseBtn: '바로 구입',
  saveTips: '최대 {{num}}% 절약',
  discount: '할인',
  priceWeek: '₩13,399',
  priceMonth: '₩10,099',
  priceYear: '₩5,099',
  billedMonth: '₩40,199월별 청구액',
  billedYear: '₩241,199월별 청구액',
  monthly: '월간',
  yearly: '연간',
  weekly: '주간',
  week: '주',
  AlreadySubscribe: '이미 구독하셨나요?',
  vipTips1: '파일 크기 제한 없음',
  vipTips2: '처리하는 파일 수에 제한 없음',
  vipTips3: '제한 없이 이미지 배경 변경',
  vipTips4: '모든 무료 도구 및 프리미엄 기능에 액세스',
  purchaseTips: '자동으로 갱신하면 언제든지 취소 가능합니다.',
  tips: '추가 정보:',
  promoCodeInvalidTips: '할인 코드가 잘못되었습니다.',
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
